import { createFormContext } from '@mantine/form';
import type { ProgrammeFormValues } from './model';

export const [ProgrammeFormProvider, useProgrammeFormContext, useProgrammeForm] =
  createFormContext<ProgrammeFormValues>();
